<template>
    <div id="registerTotal"
         v-loading.fullscreen.lock="validateLoading"
         element-loading-text="验证中..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.1)">
        <header class="registerHeader">
            <div class="main-container">
                <h1 class="left_h">
                    <a class="logoImg" href="javascript:;" @click="toIndex">
                        <img src="../../assets/images/topBar1/logoIcon.png"/>
                    </a>
                    <span>供应商注册</span>
                </h1>
                <div class="right_h">
                    <a href="javascript:;" @click="toHelp" class="help">帮助中心</a>
                    <span class="line"></span>
                    <a href="javascript:;" class="wechat">微信服务号</a>
                </div>
            </div>
        </header>
        <div class="banner">
            <img src="../../assets/images/register/bg.jpg"/>
        </div>
        <div class="main-container baseMain">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本情况" name="0">
                    <div id="register">
                        <section class="small-container">
                            <h3>注册信息<span class="tips">请先保存"基本情况"后再完成其他页面 | 带*的必须填写</span></h3>
                            <el-form
                                :label-position="labelPosition"
                                :model="userForm"
                                :rules="registerRules"
                                status-icon
                                ref="userForm"
                                label-width="150px"
                                class="userForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="登录名：" prop="userName">
                                            <el-input v-model.trim="userForm.userName" :maxlength="11" placeholder="登录名为手机号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="验证码：" prop="verificationCode" class="veriCodeItem">
                                            <el-input v-model="userForm.verificationCode" placeholder="请输入收到的验证码"></el-input>
                                            <el-button @click="sendCode" class="sendCode" :loading="isSendLoading">发送验证码</el-button>
                                            <!--<span class="countDown" v-else>60s</span>-->
                                            <span class="countDown" style="display:none;">60s</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="密码：" prop="password">
                                            <el-input type="password" :maxlength="20" v-model.trim="userForm.password" placeholder="密码为6-20位数字和字母的组合"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="再次输入密码：" prop="enPassword">
                                            <el-input type="password" v-model.trim="userForm.enPassword" :maxlength="20" placeholder="请再输入一遍您填写的密码"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>企业信息</h3>
                            <el-form :model="registerForm" :label-position="labelPosition" status-icon :rules="registerRules" ref="registerForm" label-width="250px" class="registerForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="企业名称：" prop="companyName">
                                            <el-input v-model="registerForm.companyName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="纳税人状态：" prop="taxipayerStatus">
                                            <el-select v-model="registerForm.taxipayerStatus" placeholder="请选择">
                                                <el-option
                                                    v-for="item in taxiOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-if="registerForm.creditLicenseCodeFlag == 1" :span="24">
                                        <el-form-item label="营业执照号/统一社会信用代码：" prop="socialCreditCode" class="creditCode">
                                            <el-radio-group v-model="registerForm.creditLicenseCodeFlag">
                                                <el-radio disabled :label="1">统一社会信用代码</el-radio>
                                                <el-radio disabled :label="2">营业执照号</el-radio>
                                            </el-radio-group>
                                            <el-input required  v-model="registerForm.socialCreditCode" :maxlength="18" type="text" placeholder="请输入18位数字或字母"></el-input>
                                            <span class="tip">(提示：三证合一的企业必须选择‘统一社会信用代码’)</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-else :span="24">
                                        <el-form-item label="营业执照号/统一社会信用代码：" prop="businessLicenseNumber" class="creditCode">
                                            <el-radio-group v-model="registerForm.creditLicenseCodeFlag">
                                                <el-radio :label="1">统一社会信用代码</el-radio>
                                                <el-radio :label="2">营业执照号</el-radio>
                                            </el-radio-group>
                                            <el-input required v-model="registerForm.businessLicenseNumber" type="text" :maxlength="15" placeholder="请输入13-15位数字或字母"></el-input>
                                            <span class="tip">(提示：三证合一的企业必须选择‘统一社会信用代码’)</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item v-if="registerForm.creditLicenseCodeFlag == 2" label="税务登记证号：" prop="taxCertificateNumber">
                                            <el-input v-model="registerForm.taxCertificateNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="组织机构代码证号：" v-if="registerForm.creditLicenseCodeFlag == 2"  prop="orgCertificateNumber">
                                            <el-input v-model="registerForm.orgCertificateNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="营业期限：" class="contentFull" required>
                                            <el-col :span="6">
                                                <el-form-item prop="businessYearLimitedStart">
                                                    <el-date-picker
                                                        id="startDate"
                                                        v-model="registerForm.businessYearLimitedStart"
                                                        format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                                                        type="date"
                                                        placeholder="选择起始日期">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col class="line" :span="1">至</el-col>
                                            <el-col :span="6">
                                                <el-form-item >
                                                    <el-date-picker
                                                        v-model="registerForm.businessYearLimitedEnd"
                                                        format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                                                        type="date"
                                                        id="endDate"
                                                        placeholder="选择截止日期">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <span class="tip">（提示：截止日期不填视为长期有效）</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="经营范围：" required prop="businessScope">
                                            <el-input type="textarea"  v-model="registerForm.businessScope"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="可承接省份：" prop="undertakeAreas">
                                            <el-select v-model="registerForm.undertakeAreas" multiple filterable style="width:100%;" placeholder="请选择省" @change="handelSelectChangeFunc">
                                                <el-option
                                                    v-for="item in areaOptions"
                                                    :key="item.id"
                                                    :label="item.areaName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="供方服务类别：" class="selectFull" prop="supplierServiceCategoryIds" >
                                            <el-input disabled v-model="registerForm.supplierServiceCategoryNames"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="供方分类：" class="selectFull" prop="supplierCategoryIds">
                                            <el-input v-model="registerForm.supplierCategoryNames"
                                                      readonly
                                                      id="commerceClass"
                                                      type="textarea"
                                                      @focus="selectSuperiorName"
                                                      suffix-icon="el-icon-search"
                                                      placeholder="选择供方分类"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="体系认证：">
                                            <el-input v-model="registerForm.systemCertification"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所在区域：" prop="headquartersProvince">
                                            <el-select v-model="registerForm.headquartersProvince" filterable placeholder="请选择省">
                                                <el-option
                                                    v-for="item in areaOptions"
                                                    :key="item.id"
                                                    :label="item.areaName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="总部地址：" class="capitalAddr" prop="headquartersAddress">
                                            <el-input v-model="registerForm.headquartersAddress" placeholder="请输入总部地址"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row>
                                            <el-col :span="8">
                                                <el-form-item label="企业性质：" prop="enterpriseCharacterize" class="companyNature">
                                                    <el-select v-model="registerForm.enterpriseCharacterize" placeholder="请选择" style="width: 200px;">
                                                        <el-option
                                                            v-for="item in companyOptions"
                                                            :key="item.dictValue"
                                                            :label="item.dictLabel"
                                                            :value="item.dictValue">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col v-if="registerForm.enterpriseCharacterize == '5'" :span="16">
                                                <el-form-item prop="enterpriseCharacterizeRemark" style="margin-left: 30px;">
                                                    <el-input v-model="registerForm.enterpriseCharacterizeRemark" placeholder="选择'其他'需填写"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业注册地址：" prop="enterpriseRegistAddress">
                                            <el-input v-model="registerForm.enterpriseRegistAddress"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="官网地址：">
                                            <el-input v-model="registerForm.officialWebUrl"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业成立日期：" prop="enterpriseRegistrationYear" >
                                            <el-date-picker
                                                v-model="registerForm.enterpriseRegistrationYear"
                                                style="width:100%;"
                                                :clearable=false
                                                align="right"
                                                type="month"
                                                id="buildDate"
                                                format="yyyy-MM"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="请选择日期">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="员工总数：" prop="staffNumbers">
                                            <el-input v-model.number="registerForm.staffNumbers"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="是否上市公司：" style="margin-bottom: 22.5px;" prop="companyListed">
                                            <el-radio-group v-model="registerForm.companyListed">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="0">否</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="法定代表人：" prop="legalRepresentative">
                                            <el-input v-model="registerForm.legalRepresentative"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="是否全装联会员：" style="margin-bottom: 22.5px;" prop="fullMemberFlag">
                                            <el-radio-group v-model="registerForm.fullMemberFlag">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="0">否</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="法定代表人身份证号：" prop="legalRepresentativeIdNumber">
                                            <el-input v-model.trim="registerForm.legalRepresentativeIdNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="办公面积（m²）：" prop="officeArea">
                                            <el-input  v-model="registerForm.officeArea"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="注册资本：" class="capital" prop="registeredCapital">
                                            <el-input class="unit" v-model.number="registerForm.registeredCapital"></el-input>万元
                                            <span class="tip">（提示：外企请手动根据最新汇率换算成人民币，以此作为后期入围标准条件）</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" v-if="registerForm.supplierServiceCategoryNames === '材料设备类'">
                                        <el-form-item label="供货模式：" prop="supplyMode">
                                            <el-select clearable filterable v-model="registerForm.supplyMode" placeholder="请选择">
                                                <el-option
                                                    v-for="item in supplyModeOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" v-if="registerForm.supplierServiceCategoryNames === '材料设备类'">
                                        <el-form-item label="供货品牌：" prop="supplyModeMore">
                                            <el-input v-model="registerForm.supplyModeMore" placeholder="请输入供货品牌"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>资质等级<span class="add" @click="addNatural"><img src="../../assets/images/register/btn02.png"/></span><span class="tips" style="margin-right: 20px;">提示：资质有多个时请依次新增</span></h3>
                            <el-form v-if="isHideNatural" :label-position="labelPosition" label-width="125px" class="naturalForm">
                                <el-form-item label="资质等级：" >
                                    <span>无</span>
                                    <span class="tip">（提示：若无资质需要选择，请继续填写下方信息）</span>
                                </el-form-item>
                            </el-form>
                            <el-form v-else v-for="(naturalFormItem,index) in naturalForm" :label-position="labelPosition" status-icon :key="index" :model="naturalFormItem" :rules="naturalRules" :ref="'naturalForm'+index" label-width="125px" class="naturalForm">
                                <el-row :gutter="15">
                                    <el-col :span="7">
                                        <el-form-item label="资质名称：" prop="qualificationName" >
                                            <el-input v-model="naturalFormItem.qualificationName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="资质证书编号：" prop="certificateNumber">
                                            <el-input v-model="naturalFormItem.certificateNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="资质证书有效期：" required>
                                            <el-form-item class="validity" prop="validityPeriod">
                                                <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" v-model="naturalFormItem.validityPeriod" style="width: 100%;"></el-date-picker>
                                            </el-form-item>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2">
                                        <!--<el-form-item label="" ></el-form-item>-->
                                        <el-button @click="removeNatural(index)" class="add dele" style="margin-top: -3px;" type="text"><img src="../../assets/images/register/icon_delete.png"/></el-button>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="级别：" prop="gradeLevel" required>
                                            <el-input v-model="naturalFormItem.gradeLevel"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="可承接范围："  prop="acceptableScope" required>
                                            <el-input v-model="naturalFormItem.acceptableScope"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>股东<span class="add" @click="addPartner"><img src="../../assets/images/register/btn02.png"/></span></h3>
                            <el-form v-for="(partnerFormItem,index) in partnerForm" :label-position="labelPosition" status-icon :key="index" :model="partnerFormItem" :rules="partnerRules" :ref="'partnerForm'+ index" label-width="100px" class="partnerForm">
                                <el-row >
                                    <el-col :span="11">
                                        <el-form-item label="股东：" prop="stockholderName">
                                            <el-input v-model="partnerFormItem.stockholderName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="身份证：" prop="stockholderCreditNumber" >
                                            <el-input v-model.trim="partnerFormItem.stockholderCreditNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2">
                                        <el-button v-show="index != 0" @click="removePartner(index)" class="add dele" style="margin-top: -3px;" type="text"><img src="../../assets/images/register/icon_delete.png"/></el-button>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3 style="margin-bottom: 5px;">联系方式</h3>
                            <div v-for="(contactFormItem,index) in contactForm" :key="index">
                                <h4 v-if="contactFormItem.mainFlag == 1">主联系人：<span class="tips" style="padding-left: 10px;">提示：职位是总经理或者副总经理级别的</span></h4>
                                <h4 v-else>联系人
                                    <span v-if="index == 1" @click="addContact" class="add"><img src="../../assets/images/register/btn02.png"/></span>
                                    <span class="add dele" v-else @click="removeContact(index)"><img src="../../assets/images/register/icon_delete.png"/></span>
                                </h4>
                                <el-form :model="contactFormItem" :label-position="labelPosition" status-icon :rules="contactRules" :ref="'contactForm'+index" label-width="120px" class="contactForm">
                                    <el-row >
                                        <el-col :span="12">
                                            <el-form-item label="联系人：" prop="contactName">
                                                <el-input v-model="contactFormItem.contactName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="手机：" prop="mobile">
                                                <el-input :maxlength="11" v-model.trim="contactFormItem.mobile"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="电话：" >
                                                <el-input v-model="contactFormItem.phone"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="电子邮件：" prop="email">
                                                <el-input v-model="contactFormItem.email"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="身份证：" prop="creditNumber">
                                                <el-input v-model.trim="contactFormItem.creditNumber"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="职位：" prop="positionName">
                                                <el-input v-model="contactFormItem.positionName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </section>
                        <!--<section class="small-container">-->
                            <!--<h3>获取信息类型</h3>-->
                            <!--<el-form :model="InfoTypeForm" :label-position="labelPosition" status-icon :rules="InfoTypeRules" ref="InfoTypeForm" label-width="150px" class="InfoTypeForm">-->
                                <!--<el-row>-->
                                    <!--<el-col :span="12">-->
                                        <!--<el-form-item label="推荐人类型：" prop="recommenderType">-->
                                            <!--&lt;!&ndash;<el-select style="width:100%;" v-model="InfoTypeForm.recommenderTypeName" placeholder="请选择">&ndash;&gt;-->
                                            <!--<el-select style="width:100%;" v-model="InfoTypeForm.recommenderType" placeholder="请选择">-->
                                                <!--<el-option-->
                                                    <!--v-for="item in recommendOptions"-->
                                                    <!--:key="item.dictValue"-->
                                                    <!--:label="item.dictLabel"-->
                                                    <!--:value="item.dictValue">-->
                                                <!--</el-option>-->
                                            <!--</el-select>-->
                                        <!--</el-form-item>-->
                                    <!--</el-col>-->
                                    <!--<el-col v-if="InfoTypeForm.recommenderType == 1 || InfoTypeForm.recommenderType == ''" :span="12">-->
                                        <!--<el-form-item label="推荐人：" prop="recommenderName">-->
                                            <!--<el-input v-model="InfoTypeForm.recommenderName"></el-input>-->
                                        <!--</el-form-item>-->
                                    <!--</el-col>-->
                                    <!--<el-col v-if="InfoTypeForm.recommenderType == 1 || InfoTypeForm.recommenderType == ''" :span="12">-->
                                        <!--<el-form-item label="推荐人单位：" prop="recommenderUnit">-->
                                            <!--<el-input v-model="InfoTypeForm.recommenderUnit"></el-input>-->
                                        <!--</el-form-item>-->
                                    <!--</el-col>-->
                                    <!--<el-col v-if="InfoTypeForm.recommenderType == 1 || InfoTypeForm.recommenderType == ''" :span="12">-->
                                        <!--<el-form-item label="推荐人联系电话：" prop="recommenderPhone">-->
                                            <!--<el-input :maxlength="11" v-model.trim="InfoTypeForm.recommenderPhone"></el-input>-->
                                        <!--</el-form-item>-->
                                    <!--</el-col>-->
                                    <!--<el-col :span="14">-->
                                        <!--<el-form-item label="说明：" prop="recommenderIllustration">-->
                                            <!--<el-input :rows="3" type="textarea" autosize v-model="InfoTypeForm.recommenderIllustration"></el-input>-->
                                        <!--</el-form-item>-->
                                    <!--</el-col>-->
                                <!--</el-row>-->
                            <!--</el-form>-->
                        <!--</section>-->
                        <section class="small-container">
                            <h3>关联公司信息<span class="tips">提示：只能关联在当代置业供应商外网注册过的母公司信息</span></h3>
                            <el-form :model="affiliateForm" :label-position="labelPosition" status-icon :rules="affiliateRules" ref="affiliateForm" label-width="250px" class="affiliateForm">
                                <el-form-item label="有无关联公司：" prop="hasRelateParentCompany">
                                    <el-radio-group v-model="affiliateForm.hasRelateParentCompany">
                                        <el-radio label="1">有</el-radio>
                                        <el-radio label="0">无</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-row v-show="affiliateForm.hasRelateParentCompany == 1">
                                    <el-col :span="12">
                                        <el-form-item label="关联公司名称：" prop="relateParentCompanyId">
                                            <!--<el-input v-model="affiliateForm.relateParentCompanyName"></el-input>-->
                                            <el-select @change="changeCompany" style="width:100%;" filterable v-model="affiliateForm.relateParentCompanyId" placeholder="请选择关联公司名称">
                                                <el-option
                                                    v-for="item in relateOptions"
                                                    :key="item.id"
                                                    :label="item.relateParentCompanyName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="法人：" required>
                                            <el-input v-model="affiliateForm.legalRepresentative" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="营业执照号/统一社会信用代码：" required>
                                            <el-input v-if="affiliateForm.socialCreditCode" v-model="affiliateForm.socialCreditCode"  disabled></el-input>
                                            <el-input v-else v-model="affiliateForm.businessLicenseNumber"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="注册地址：" required>
                                            <el-input v-model="affiliateForm.registAddress" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>业务状况</h3>
                            <el-form :model="businessForm" :label-position="labelPosition" status-icon :rules="businessRules" ref="businessForm" label-width="250px" class="businessForm">
                                <el-row>
                                    <!--<el-col :span="12">
                                        <el-form-item label="主要业务区域：" prop="mainBusinessAreaIds">
                                            <el-input v-model="businessForm.mainBusinessAreaIds" placeholder="请输入主要业务区域"></el-input>
                                        </el-form-item>
                                    </el-col>-->
                                    <!-- <el-col :span="12">
                                        <el-form-item label="近年营业额：" prop="lastYearSales">
                                            <el-input class="unit" v-model.number="businessForm.lastYearSales"></el-input>万元
                                        </el-form-item>
                                    </el-col> -->
                                    <el-col :span="12">
                                        <el-form-item label="平均年产能：" prop="avgAnnualCapacity">
                                            <el-input v-model="businessForm.avgAnnualCapacity"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地地址：" prop="processBaseAddress">
                                            <el-input v-model="businessForm.processBaseAddress"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地负责人：" prop="processBaseChargePerson" >
                                            <el-input v-model="businessForm.processBaseChargePerson"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地联系方式：" prop="processBaseContactMode" >
                                            <el-input v-model="businessForm.processBaseContactMode"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地规模：" prop="processBaseScale" >
                                            <el-input v-model="businessForm.processBaseScale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地设备：" prop="processBaseEquipment" >
                                            <el-input v-model="businessForm.processBaseEquipment"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司技术力量：" prop="technicalAbility" >
                                            <el-input v-model="businessForm.technicalAbility"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司劳动力组织："  prop="laborForceOrg">
                                            <el-input v-model="businessForm.laborForceOrg"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div>
                                <h4>近年营业额
                                    <span  @click="addBaseBusiness" class="add"><img src="../../assets/images/register/btn02.png"/></span>
                                </h4>
                                <el-form v-for="(baseBusinessInfoItem,index) in baseBusinessInfo" :label-position="labelPosition" status-icon :key="index" :model="baseBusinessInfoItem" :rules="baseBusinessInfoRules" :ref='"baseBusinessInfoItem" + index' label-width="125px" class="partnerForm businessInfo">
                                    <el-row >
                                        <el-col :span="11">
                                            <el-form-item label="年份：" prop="businessYear" >
                                                 <el-date-picker v-model="baseBusinessInfoItem.businessYear" type="year" format="yyyy" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择年"> </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-form-item label="营业额：" prop="businessVolume" >
                                                <el-input class="unit" v-model="baseBusinessInfoItem.businessVolume"></el-input>万元
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="2" v-if="baseBusinessInfo.length > 1">
                                            <el-button @click="removeBaseBusiness(index)" class="add dele" style="margin-top: -3px;" type="text"><img src="../../assets/images/register/icon_delete.png"/></el-button>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </section>
                        <section class="small-container">
                            <h3>备注<span class="tips">提示：字数限制500汉字</span></h3>
                            <el-input class="remarks" v-model="registerForm.remarks" style="margin-top: 20px;" :rows="5" :maxlength='500' type="textarea" ></el-input>
                        </section>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="近三年业绩" name="1">
                    <div id="achievement">
                        <div class="small-container strategy">
                             <h3>战略合作<span class="add" @click="addStrategy"><img src="../../assets/images/register/btn02.png"/></span></h3>
                            <el-form v-if="!strategyForm.length" :label-position="labelPosition" label-width="125px" class="naturalForm">
                                <el-form-item label="战略合作：" >
                                    <span>无</span>
                                    <span class="tip">（提示：若无战略合作，请继续填写下方信息）</span>
                                </el-form-item>
                            </el-form>
                            <el-form v-else :model="strategyFormItem" v-for="(strategyFormItem,index) in strategyForm" :key="strategyFormItem.index" :label-position="labelPosition" :ref="'strategyForm'+index" :rules="numberRules" label-width="160px" class="strategiCooperation">
                                <!-- <h3>
                                    <span >战略合作</span>
                                    <span class="add" v-if="index == 0" @click="addStrategy"><img src="../../assets/images/register/btn02.png"/></span>
                                    <span class="add dele" v-else @click="removeStrategy(index)"><img src="../../assets/images/register/icon_delete.png"/></span>
                                </h3> -->
                                <el-row>
                                    <el-col :span="24"><span class="add dele" @click="removeStrategy(index)"><img src="../../assets/images/register/icon_delete.png"/></span></el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作单位名称：" required prop="cooperativeUnitName">
                                            <el-input v-model="strategyFormItem.cooperativeUnitName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作类别："  prop="cooperativeCategoryName">
                                            <el-input v-model="strategyFormItem.cooperativeCategoryName"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item class="time startTime" label="合作起止时间：" required>
                                            <el-col :span="7">
                                                <el-form-item prop="cooperativeStartTime">
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :id="'cooperativeStartTime'+index" v-model="strategyFormItem.cooperativeStartTime" style="width: 100%;"></el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="1">&nbsp;至</el-col>
                                            <el-col :span="7">
                                                <el-form-item prop="cooperativeEndTime">
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :id="'cooperativeEndTime'+index" v-model="strategyFormItem.cooperativeEndTime" style="width: 100%;"></el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所获奖项：" >
                                            <el-input v-model="strategyFormItem.awards"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作区域：" prop="cooperativeAreaName">
                                            <el-input v-model="strategyFormItem.cooperativeAreaName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作额度：" prop="cooperationAmount">
                                            <el-input class="unit" v-model="strategyFormItem.cooperationAmount"></el-input>万元
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="合同附件:" prop="lstattachmentVO">
                                            <page-upload :files="strategyFormItem.lstattachmentVO"
                                                         :editFlag="true"
                                                         :attachmentType="1"
                                                         :limitType="1"
                                                        :isIconTable="1"></page-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <div class="small-container strategy">
                            <el-form :model="commonFormItem" v-for="(commonFormItem,index) in commonForm" :key="commonFormItem.index" :label-position="labelPosition" :ref="'commonForm'+index" :rules="numberRules" label-width="160px" class="strategyForm ordinary">
                                <h3>
                                    一般合作
                                    <span class="add" v-if="index == 0" @click="addCommon"><img src="../../assets/images/register/btn02.png"/></span>
                                    <span class="add dele" v-else @click="removeCommon(index);isDeleate=true"><img src="../../assets/images/register/icon_delete.png"/></span>
                                    <span v-if="index == 0" class="tips">提示：请输入至少3项除战略合作外的合作项目</span>
                                </h3>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="合作单位名称：" prop="cooperativeUnitName">
                                            <el-input v-model="commonFormItem.cooperativeUnitName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" >
                                        <el-form-item label="合作项目：" prop="cooperativeProjectName">
                                            <el-input v-model="commonFormItem.cooperativeProjectName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item class="time startTime" label="合作起止时间：" required >
                                            <el-col :span="7">
                                                <el-form-item prop="cooperativeStartTime">
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :id="'cooperativeStartTime'+index" v-model="commonFormItem.cooperativeStartTime" style="width: 100%;"></el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="1">&nbsp;至</el-col>
                                            <el-col :span="7">
                                                <el-form-item prop="cooperativeEndTime">
                                                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :id="'cooperativeEndTime'+index" v-model="commonFormItem.cooperativeEndTime" style="width: 100%;"></el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="项目规模：" prop="cooperativeProjectScale">
                                            <el-input v-model="commonFormItem.cooperativeProjectScale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作范围："  prop="cooperationScope">
                                            <el-input v-model="commonFormItem.cooperationScope"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作区域：" prop="cooperativeAreaName">
                                            <el-input v-model="commonFormItem.cooperativeAreaName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作额度：" prop="cooperationAmount">
                                            <el-input class="unit" v-model="commonFormItem.cooperationAmount"></el-input>万元
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="合同附件:" prop="lstattachmentVO">
                                            <page-upload :files="commonFormItem.lstattachmentVO"
                                                         :editFlag="true"
                                                         :attachmentType="1"
                                                         :limitType="1"
                                                        :isIconTable="1"></page-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="银行账户信息" name="3">
                    <div class="small-container strategy">
                        <el-form :model="bankInfoFormItem" v-for="(bankInfoFormItem,index) in bankInfoForm" :key="index" :label-position="labelPosition" :ref="'bankInfoFormItem'+index" :rules="bankRules" label-width="160px" class="strategyForm ordinary">
                            <h3>
                                <span >银行账户信息</span>
                                <span class="add" v-if="index == 0" @click="addBankInfo"><img src="../../assets/images/register/btn02.png"/></span>
                                <span class="add dele" v-else @click="removeBankInfo(index)"><img src="../../assets/images/register/icon_delete.png"/></span>
                            </h3>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="开户行类型" prop="accountType" required>
                                         <el-select v-model="bankInfoFormItem.accountType" placeholder="请选择">
                                            <el-option v-for="item in bankTypeList" :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="开户行：" prop="bankName" required>
                                        <el-input v-model="bankInfoFormItem.bankName"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="收款账号：" prop="accountNumber" required>
                                        <el-input v-model="bankInfoFormItem.accountNumber"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="联行号：" prop="bankNumber">
                                        <el-input v-model="bankInfoFormItem.bankNumber"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="附件清单" name="2">
                    <div id="annex">
                        <div class="small-container">
                            <h3>附件清单<span class="tips">带*的必须上传，供方在上传多页扫描件时合并后再上传</span></h3>
                            <el-form :model="mapAttachmentOptions" :rules="annexRules" ref="annexForm" label-width="360px" class="annexForm">
                                <el-form-item v-for="(item,key) in mapAttachmentOptions"
                                              :key="key"
                                              :prop="key < 3 ? 'fileList' : ''"
                                              :label="item.label+':'">
                                    <page-upload :files="item.fileList"
                                                 :editFlag="true"
                                                 :attachmentType="key"
                                                 :limitType="1"
                                                :isIconTable = '1'></page-upload>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div style="margin: 10px 0 10px;">
                <el-button v-if="activeName == '0'" disabled type="primary">上一步</el-button>
                <el-button v-else  type="primary" @click="prev">上一步</el-button>
                <el-button v-if="activeName == '2'"  type="success" @click="submit">完成提交</el-button>
                <el-button v-else type="primary" @click="next">下一步</el-button>
            </div>
        </div>

        <el-dialog
            id="article"
            title="注册须知"
            :visible.sync="centerDialogVisible"
            :close-on-click-modal='showModal'
            :close-on-press-escape='showModal'
            :show-close='showModal'
            width="50%"
            top="10vh"
            center>
            <div>
                <h3 class="center">欢迎您在此注册为当代节能采购平台会员！</h3>
                <section>
                    <h3 class="center">提 示</h3>
                    <p class="indent padd">
                        请仔细阅读下述文本，当代节能采购平台依据以下服务条款提供您所享有的服务，如果您接受，请点按“同意”进入注册页面。 请您仔细阅读并充分理解本文本。本文本采用电子签署、点击提交方式, 您自愿点选"同意"并完成注册, 即视为已完全同意并接受本文本内容, 并愿受其约束。您若不同意本文本的任何条款, 请不要点选 "同意"。
                    </p>
                </section>
                <p class="indent padd">
                    当代节能采购平台各项电子服务的所有权和运作权归当代节能置业股份有限公司。当代节能采购平台提供的服务将完全按照其发布的章程、服务条款和操作规则严格执行。用户必须完全同意所有服务条款并完成注册程序，才能成为当代节能采购平台的正式会员，这也意味着用户与当代节能采购平台达成协议并接受所有的服务条款。
                </p>
                <ul>
                    <li>
                        <h3>一、 定义：</h3>
                        <div class="padd">
                            <p class="indent">如无特别说明，下列术语在本章程中的含义为：</p>
                            <p class="indent">“公司”：指当代节能置业股份有限公司；</p>
                            <p class="indent">“网站”：指当代节能采购平台；</p>
                            <p class="indent">“用户”：指使用当代节能采购平台的所有因特网用户；</p>
                            <p class="indent">“会员”：指当代节能采购平台的正式会员；</p>
                            <p class="indent">“服务条款”： 指本章程所列明的所有服务和约定内容；</p>
                            <p class="indent">“网上交易”：指网站借助因特网技术为会员提供的建材项目招、投标和产品采购、销售交易活动；</p>
                        </div>
                    </li>
                    <li>
                        <h3>二、 会员资料：</h3>
                        <div class="padd">
                            <p class="indent">基于当代节能采购平台所提供的网络服务的重要性，会员应同意：</p>
                            <ul class="indent">
                                <li>(1)向网站提供及时、详尽及准确真实的用户资料。</li>
                                <li>(2)不断更新注册资料，符合及时、详尽、准确的要求。所有原始键入的资料网站将引用为注册资料。 网站对会员注册资料和交易资料有保密义务。</li>
                                <li>(3)网站为统计分析、内部管理之目的，有权使用会员资料。 在得到会员许可的情况下，网站可以将客户资料向第三方提供。会员向网站提供的信息将只被用于订货和为会员提供更好的服务。</li>
                                <li>(4)即使未得到会员的明确许可，网站仍可根据法律规定向有权查询的法定机构提供会员资料，或为交易的需要向第三方提供必要的客户资料。</li>
                                <li>(5)会员的个人资料如有变更，应及时通知网站，否则由此发生的风险和责任由会员自行承担。</li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <h3>三、 会员的用户名和密码：</h3>
                        <p class="indent padd">网站发给会员的用户名和密码是网站在提供网上交易过程中识别会员的唯一依据。会员须妥善保管用户名和密码。无论会员实际上是否将用户名和密码提供给他人使用，均须对该用户名和密码下进行的一切活动和交易事件负责。如用户名或密码遗失、被盗，会员应立即通知网站，对报失之前发生的交易自行承担后果。但会员可按照规定申请发放新的用户名和密码。如会员将密码遗忘或怀疑密码已被他人知悉，可按规定随时在网站变更密码。</p>
                    </li>
                    <li>
                        <h3>四、 网上服务功能：</h3>
                        <dl class="padd">
                            <dt class="indent">（一）信息服务：服务对象是所有因特网用户，具体功能包括：</dt>
                            <dd>（1）网站的基本信息发布，包括网站简介、网站导航；</dd>
                            <dd>（2）招标采购产品信息发布，包括产品分类、产品介绍、产品的市场动态等；</dd>
                            <dd>（3）网站建材采购项目的招标信息发布；</dd>
                            <dd>（4）新闻发布，涉及房地产行业和建材行业的行业信息；</dd>
                            <dd>（5）通告，所有发给用户的通告包括：服务条款的修改、服务变更、或其它重要事件的通告都通过重要页面的公告或电子邮件或常规的信件形式传送。</dd>
                            <dt class="indent">（二）会员服务：服务对象是网站的正式会员，除包括信息服务功能外，还包括：</dt>
                            <dd>（1）招标项目中标查询；</dd>
                            <dd>（2）会员用户名、密码变更、报失；</dd>
                            <dd>（3）会员网上反馈意见的处理；</dd>
                            <dd>（4）会员网上投诉的处理。</dd>
                        </dl>
                    </li>
                    <li>
                        <h3>五、服务约定：</h3>
                        <dl class="padd">
                            <dt class="indent">（一）网站运用自己的操作系统通过国际互联网络为用户提供网络服务。同时，用户必须：</dt>
                            <dd>(1) 自行负担个人上网所支付的与此服务有关的电话费用、网络费用；</dd>
                            <dd>(2) 自行配备上网的所需设备， 包括个人电脑、调制解调器或其他必备上网装置。</dd>
                            <dt class="indent">（二）信息发布</dt>
                            <dd>
                                <p class="indent">1、用户对服务的使用标准是根据所有适用于同类网站的国家法律、地方性法规和国际惯例制定的。用户使用网络过程中必须遵守：</p>
                                <p class="indent2">(1)不得以非法目的使用网络服务；</p>
                                <p class="indent2">(2)不干扰或扰乱网络服务。</p>
                                <p class="indent2">用户的行为准则是遵守根据因特网法规、政策和惯例，用户承诺不传输任何不符合国家法律、当地法规和国际惯例的信息资料。另外，用户也不能传输任何教唆他人构成犯罪行为的资料；不能传输助长国内不利条件和涉及国家安全的资料。未经许可而非法进入其它电脑系统是禁止的。若用户的行为不符合以上提到的服务条款，网站将做出独立判断并立即终止向其提供网络服务。用户需对自己在网上的行为独立承担法律责任。用户若在网站上散布和传播反动、色情或其他违反国家法律法规的信息，网站的系统记录有可能作为用户违反法律的证据。</p>
                            </dd>
                            <dd class="indent">2、用户单独承担就发布内容所产生的责任。用户在发表的信息中加入宣传资料或参与广告策划，要遵守国家有关广告方面的法律法规，保证不侵犯他人合法权益。用户在网站上采取的任何促销方法（如展示他们的产品），及就运输货物、付款、服务、商业条件、担保及、广告等达成交条件都只约束相应的用户和广告销售商，公司不承担任何责任，网站不对这类广告的内容及其后果承担任何法律责任。另外，网站不对用户所发布信息的删除或储存失败负责。</dd>
                            <dt class="indent">（三）网络服务内容的所有权</dt>
                            <dd class="indent">网站所提供的包括文字、软件、声音、图片、录像、图表、广告中的全部内容，以及网站为用户提供的其他信息。所有这些内容受版权、商标等有关法律的保护。所以，用户只能在网站和广告商授权下才能使用这些内容，而不能擅自复制、改编这些内容、或创造与内容有关的派生产品。网站所有的文章版权归原文作者和网站共同所有，任何人需要转载网站的文章，必须经原文作者和网站同意和授权。</dd>
                        </dl>
                    </li>
                    <li>
                        <h3>六、 网上公示的内容：</h3>
                        <dl class="padd">
                            <dt class="indent">网上公示的服务对象是网站的正式会员。具体功能包括：</dt>
                            <dd>（1）网上招标，即实现采购方会员在网站进行建材项目的采购招标；</dd>
                            <dd>（2）网上投标，即实现供应商会员根据网上招标要求在网站投递标书；</dd>
                            <dd>（3）网上开标，即在网站公布中标结果。</dd>
                        </dl>
                    </li>
                    <li>
                        <h3>七、章程条款的修改和服务修订：</h3>
                        <p class="indent padd">网站有权在必要时修改章程中的服务条款，网站服务条款一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动取消获得的网络服务。如果用户继续享用网络服务，则视为接受服务条款的变动。网站保留随时修改或终止服务的权利。</p>
                    </li>
                    <li>
                        <h3>八、 终止服务：</h3>
                        <p class="indent padd">用户可以行使终止使用网络服务的权利，如果用户违背了章程服务条款的规定，网站有终止对其提供网络服务的权利，但终止方须提前10个工作日以书面或电子邮件方式通知对方。服务终止意味客户会员资格的取消，但服务终止并不意味着终止前所发生的未完成交易的撤销，也不能消除因终止前的交易所带来的任何法律后果。</p>
                    </li>
                    <li>
                        <h3>九、 法律适用和效力：</h3>
                        <div class="padd">
                            <p class="indent">本章程是对会员与网站的其他既有协议和约定的补充而非替代，如本章程与其他既有协议和约定有冲突，应以本章程为准。</p>
                            <p class="indent">本章程的任何条款如因任何原因而被确认无效，都不影响本协议其他条款的效力。</p>
                            <p class="indent">本章程自网站审核会员通过之日起生效。</p>
                        </div>
                    </li>
                    <li>
                        <h3>十、 章程的解释：</h3>
                        <p class="indent">本章程由当代节能负责解释。</p>
                    </li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <p class="readed">
                    <el-checkbox v-model="checked">已阅读注册须知</el-checkbox>
                </p>
                <el-button class="disagree" type="primary" @click="toLogin">不同意</el-button>
                <el-button  @click="toRegister">同意</el-button>
            </div>
        </el-dialog>
        <!--树形-->
        <el-dialog
            title="选择供应商分类"
            :visible.sync="tree.supplierCategoryDialog"
            width="40%"
            :close-on-click-modal="$root.dialogAutoClose"
            :close-on-press-escape="$root.dialogAutoClose"
            :before-close="handleCloseSupplierCategory">
            <div style="max-height: 300px;overflow-y: auto;">
                <el-tree :data="tree.supplierCategoryTreeData"
                         :props="tree.supplierCategoryTreeDataDefaultProps"
                         default-expand-all
                         highlight-current
                         :expand-on-click-node="false"
                         :show-checkbox="true"
                         :default-checked-keys="tree.defaultKeys"
                         node-key="id"
                         ref="treeSupplierCategory"
                         @node-click="handleCheckChange"></el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseSupplierCategory">取 消</el-button>
            <el-button type="primary" @click="handleConfirmSupplierCategory">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
    import md5 from 'js-md5';
    import { rules,registerRules,naturalRules,partnerRules,contactRules,InfoTypeRules,affiliateRules,businessRules,numberRules,annexRules ,bankRules,baseBusinessInfoRules} from '../../util/rules';

    import {arrayToTree, treeToArrayHelper, treeToArray} from '../../util/index';
    export default {
        name: 'register',
        data() {
            var validUpload = (rule,value,callback) => {
//                console.log(888,rule,value,callback)
            };
            return {
                validateLoading: false,
                isSendLoading: false,//是否显示loading状态，发送验证码
                userForm: {
                    userName: '',//登录名
                    verificationCode: '',
                    password: '',
                    enPassword: ''
                },
                registerForm: {
                    id:'',
                    companyName:'',//企业名称
                    taxipayerStatus: '',//纳税人状态
                    taxipayerStatusName: '',//纳税人状态名称
                    socialCreditCode: '',//统一社会信用代码
                    businessLicenseNumber: '',//营业执照号
                    taxCertificateNumber: '',//税务登记证号
                    orgCertificateNumber: '',//组织机构代码证号
                    intentionRegionalCompanyIds: '',//意向地区公司ids
                    intentionRegionalCompanyIdsArr: [],//意向地区公司ids
                    intentionRegionalCompanyNames: '',//意向地区公司名称
                    supplierServiceCategoryIds: '',//供方服务类别
                    supplierServiceCategoryNames: '',//供方服务类别名称
                    supplierCategoryIds: '',//供方分类ids
                    supplierCategoryNames: '',//供方分类名称
                    systemCertification: '',//体系认证
                    headquartersProvince: '',//总部地址省id
                    headquartersProvinceName: '',//总部地址省名称
                    headquartersCity: '',//总部地址市id
                    headquartersCityName: '',//总部地址市名称
                    headquartersArea: '',//总部地址区id
                    headquartersAreaName: '',//总部地址区名称
                    headquartersAddress: '',//总部地址
                    enterpriseCharacterize: '',//企业性质
                    enterpriseCharacterizeName: '',//企业性质名称
                    enterpriseCharacterizeRemark: '',//企业性质其他名称
                    officialWebUrl: '',//官网地址
                    enterpriseRegistAddress: '',//企业注册地址
                    legalRepresentative: '',//法定代表人
                    legalRepresentativeIdNumber: '',//法定代表人身份证号
                    enterpriseRegistrationYear: '',//企业注册年份
                    officeArea: '',//办公面积
                    registeredCapital: '',//注册资本
                    supplyMode: '',//供货模式
                    supplyModeMore:'' , // 供货品牌
                    remarks: '',//备注信息
                    creditLicenseCodeFlag: 1,//单选，统一社会信用代码1 或 营业执照2
                    businessYearLimitedStart: '',//营业期限开始
                    businessYearLimitedEnd: '',//营业期限结束
                    companyListed: 0,//单选，是否上市公司（0：否，1：是）
                    fullMemberFlag: 0,//单选，是否全装联会员（0：否，1：是）
                    staffNumbers: '',//员工总数
                    headquartersProvince: '',//所在区域省份id
                    headquartersProvinceName: '',//所在区域省份名称
                    undertakeAreas: [],//可承接省份
                    businessScope: ''//经营范围
                },
                registerRules: registerRules,
                naturalForm: [//资质等级
                    /*{
                        qualificationName:'',//资质名称
                        certificateNumber:'',//资质证书编号
                        validityPeriod:'',//资质证书有效期
                    }*/
                ],
                isHideNatural: true,//是否隐藏资质等级输入框；
                naturalRules: naturalRules,
                partnerForm: [//股东
                    {
                        stockholderName:'',//股东姓名
                        stockholderCreditNumber:''//股东身份证
                    }
                ],
                partnerRules: partnerRules,
                contactForm: [//联系方式
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'1'//是否主联系人（0：否，1：是）}
                    },
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'0'//是否主联系人（0：否，1：是）}
                    }
                ],
                contactRules: contactRules,
                InfoTypeForm:{ //获取信息类型
                    recommenderType:'',//推荐人类型
                    recommenderTypeName:'',//推荐人类型名称
                    recommenderName:'',//推荐人姓名
                    recommenderUnit:'',//推荐人单位
                    recommenderPhone:'',//推荐人电话
                    recommenderIllustration:''//推荐人说明
                },
                InfoTypeRules: InfoTypeRules,
                affiliateForm: {//获取关联母公司信息
                    hasRelateParentCompany: '0',//有无关联公司（0：否，1：是）hasRelateParentCompany
                    relateParentCompanyName:'',//关联母公司名称
                    relateParentCompanyId: '',//关联母公司Id
                    legalRepresentative:'',//法人
                    socialCreditCode:'',//统一社会信用代码
                    businessLicenseNumber:'',//营业执照号
                    creditLicenseCodeFlag: 1,//1 代表统一社会信用代码，2 代表营业执照号
                    registAddress:''//注册地址
                },
                affiliateRules: affiliateRules,
                businessForm: {//业务状况
                    mainBusinessAreaIds:'',//主要业务区域ids
                    mainBusinessAreaNames:'',//主要业务区域名称
                    lastYearSales:'',//上年营业额
                    avgAnnualCapacity:'',//平均年产能
                    processBaseAddress:'',//加工基地地址
                    processBaseChargePerson:'',//加工基地负责人
                    processBaseContactMode:'',//加工基地联系方式
                    processBaseScale:'',//加工基地规模
                    processBaseEquipment:'',//加工基地设备
                    technicalAbility:'',//公司技术力量
                    laborForceOrg:''//公司劳动力组织
                },
                businessRules: businessRules,
                commonForm: [//一般合作
                    {
                        suppliersId: '', //供方id
                        cooperativeUnitName: '',//合作单位名称
                        cooperativeProjectName: '',//合作项目名称
                        cooperativeProjectScale: '',//项目规模
                        cooperationScope: '',//合作范围
                        cooperativeAreaName: '',//合作区域名称
                        cooperationAmount: null,//合作额度
                        lstattachmentVO: [], //合同附件
                        cooperativeStartTime: '',//合作起始时间
                        cooperativeEndTime: '',//合作截止时间
                    }
                ],
                strategyForm: [//近三年業績 战略合作
                    // {
                    //     suppliersId: '', //供方id
                    //     cooperativeUnitName: '',//合作单位名称
                    //     cooperativeCategoryName: '',//合作类别名称
                    //     cooperativeStartTime: '',//合作起始时间
                    //     cooperativeEndTime: '',//合作截止时间
                    //     awards: '',//所获奖项
                    //     cooperativeAreaName: '',//合作区域名称
                    //     cooperationAmount: null,//合作额度
                    //     lstattachmentVO: [] //合同附件
                    // }
                ],
                numberRules: numberRules,
                mapAttachmentOptions: {//附件清单
                    2: {
                        label: '营业执照/统一社会信用代码',
                        fileList: []
                    },
                    3: {
                        label: '增值税纳税人申请认定表',
                        fileList: []
                    },
                    4: {
                        label: '上年审计报告或年营业额证明文件',
                        fileList: []
                    },
                    // 5: {
                    //     label: '质量保证体系认证文件',
                    //     fileList: []
                    // },
                    6: {
                        label: '安全生产许可证',
                        fileList: []
                    },
                    7: {
                        label: '生产经营许可证',
                        fileList: []
                    },
                    8: {
                        label: '资质等级证书',
                        fileList: []
                    },
                    9: {
                        label: '管理体系认证',
                        fileList: []
                    },
                    10: {
                        label: '认证或荣誉证书',
                        fileList: []
                    },
                    11: {
                        label: '供方名称变更单(工商局盖章版)',
                        fileList: []
                    },
                    12: {
                        label: '其他附件',
                        fileList: []
                    },
                    45: {
                        label: '联系人社保证明',
                        fileList: []
                    }
                },
                annexRules: {
                    fileList: [
                        { validator: validUpload,message: '附件不能为空',type: 'array',required: true }
                    ]
                },
                taxiOptions: [],//纳税人状态
                companyOptions: [],//企业性质
                recommendOptions: [],//推荐人类型
                intentionOptions: [],//意向地區公司
                relateOptions: [],//關聯母公司信息
                //供货模式
                supplyModeOptions: [],
                areaOptions: [],//所在区域信息
                activeName: '0',//tabs切换名称；
                centerDialogVisible: true,//是否显示注册须知；
                showModal: false,//是否显示弹层遮罩层及关闭按钮
                checked: true,//注册须知是否勾选了已阅读；
                labelPosition: 'right',//表单里的label定位
                tree: {//供方分类树形弹框
                    supplierCategoryTreeData: [], //供方分类树形数据
                    supplierCategoryTreeDataDefaultProps:  {
                        children: 'children',
                        label: 'text'
                    },
                    supplierCategoryDialog: false,  //供方分类弹出框
                    defaultKeys: [],
                },
                fileList: [],
                fileListStrategy: [],
                indexStrategy: null,
                fileListCommon: [],
                indexCommon: null,
                canSubmit: false ,
                bankInfoForm:[
                    {
                        accountType:'', // 开户行类型 1：国内 2：国外
                        accountNumber:'' , // 银行账号
                        bankName:'', // 开户行
                        bankNumber:'' , // 联行号

                    }
                ],
                bankTypeList:[
                    {
                        value:'1',
                        label:'国内'
                    },
                    {
                        value:'2',
                        label:'国外'
                    }
                ],
                bankRules:bankRules,
                baseBusinessInfo:[
                    {
                        businessYear:'', // 年份
                        businessVolume:'' // 营业额
                    }
                ],
                baseBusinessInfoRules:baseBusinessInfoRules
            }
        },
        created(){
            let checkCompanyName = (rule, value, callback) => {
                this.$root.checkCompanyName(this.registerForm.companyName,this.registerForm.id,function (res) {
                    if(!res.data){
                        callback();
                    }else{
                        callback(new Error('企业名称已存在'));
                    }
                });
            };
            var obj = {
                password: [
                    {required: true, message: '请输入登录密码', trigger: 'blur'},
                    {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
                ],
                enPassword: [
                    {required: true, message: '请再次输入登录密码', trigger: 'blur'},
                    {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/, message: '密码为6-20位数字和字母的组合', trigger: 'blur'},
                    {validator: this.validatePass, trigger: 'blur'}
                ],
                socialCreditCode:[
                    {required: true, message: '请输入营业执照号/统一社会信用代码'},
                    { validator: this.checkSocialCode, trigger: 'blur'}
                ],
                businessLicenseNumber:[
                    {required: true, message: '请输入营业执照号/统一社会信用代码'},
                    { validator: this.checkSocialCode, trigger: 'blur'}
                ],
                companyName:[
                    {required: true, message: '请输入企业名称', trigger: 'blur'},
                    {validator: checkCompanyName, trigger: 'blur'}
                ],

            };
            this.registerRules = Object.assign(this.registerRules,obj);//增加密码校验规则；
           console.log(this.registerRules)
        },
        mounted() {
            var _this = this;
//            taxipayer_status
            getType('taxipayer_status');//获取纳税人状态
            getType('enterprise_characterize');//获取企业性质
            getType('recommender_type');//获取推荐人类型
            getType('supply_mode');//获取供货模式
            function getType(type) {
                _this.$root.getHttp('v1/sysDict/public/getDictListByDictType?dictType=' + type, function (res) {
                    if (type == 'taxipayer_status') {
                        _this.taxiOptions = res.data.data;//获取纳税人状态
                    } else if (type == 'enterprise_characterize') {
                        _this.companyOptions = res.data.data;//获取企业性质
                    } else if (type == 'recommender_type') {
                        _this.recommendOptions = res.data.data;//获取推荐人类型
                    }else if(type == 'supply_mode'){
                        _this.supplyModeOptions = res.data.data;//获取供货模式
                        _this.supplyModeOptions.forEach((item,i) => {
                            item.dictValue = parseInt(item.dictValue);
                        })
                    }
                });
            }
       /*     _this.$root.postHttp('v1/sRegionalCompany/public/getRegionalCompanyList', {//獲取意向地區公司
                "pageFlag": 0,
                "pageNumber": 0,
                "pageSize": 0,
                "regionalCompanyCode": "",
                "regionalCompanyName": ""
            }, function (res) {
                _this.intentionOptions = res.data.data.list;
            });*/
//            relateOptions//獲取关联母公司
            _this.$root.getHttp('v1/sSuppliers/public/getParentCompanyList', function (res) {
//                console.log('母公司',res)
                _this.relateOptions = res.data.data || [];
            });
//            获取供应商分类
            _this.$root.postHttp('v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{
                "categoryStatus": '1',
                "pageFlag": 0,
                "pageNumber": 0,
                "pageSize": 0
            },function(res){
                _this.tree.supplierCategoryTreeData = res.data.data.tree;
            });
//            获取所在区域省份
            _this.$root.getHttp('/v1/sysArea/public/allList', function (res) {
//                console.log('所在区域',res)
                _this.areaOptions = res.data.data || [];
            });
        },
        methods: {
            handelSelectChangeFunc(val){//根据可承接省份，来动态获取意向地区公司；
                let that = this;
                let companyIdsArr = [];
                val.find(function (item) {
                    let obj = that.areaOptions.find(function (value) {
                        if(value.id == item) return value;
                    });
                    if(obj.companyIds){
                        companyIdsArr = companyIdsArr.concat(obj.companyIds.split(','));
                    }
                });
//                console.log('省份',companyIdsArr)
                that.registerForm.intentionRegionalCompanyIdsArr = that.$root.uniqueArr(companyIdsArr);
                that.registerForm.intentionRegionalCompanyIds = that.$root.uniqueArr(companyIdsArr).join(',');
                that.registerForm.undertakeAreas = val;
            },
            checkSocialCode(rule,value,callback){
//                console.log(value)
                var _this = this;
                this.$http.post('/v1/sSuppliers/public/checkCodeOrNumber',{
                    "businessLicenseNumber": _this.registerForm.businessLicenseNumber,
                    "creditLicenseCodeFlag": _this.registerForm.creditLicenseCodeFlag,
                    "socialCreditCode":  _this.registerForm.socialCreditCode,
                    "supplierId": ''
                }).then( (res) => {
                    if(res.data.code == 1){
                        callback();
                    } else {
                        callback(new Error(res.data.msg));
                    }
                })
            },
            changeCompany(val){//关联母公司选项改变时触发；
                var _this = this;
                this.relateOptions.forEach( (item,index) => {
                    if(item.id == val){
                        _this.affiliateForm.registAddress = item.registAddress;
                        _this.affiliateForm.socialCreditCode = item.socialCreditCode;
                        _this.affiliateForm.legalRepresentative = item.legalRepresentative;
                        _this.affiliateForm.creditLicenseCodeFlag = item.creditLicenseCodeFlag;
                    }
                })
            },
            toIndex(){
                this.$root.activeIndex = 'home';
                this.$router.push('/');
            },
            validatePass(rule, value, callback){
                //验证密码
                if(this.userForm.enPassword != this.userForm.password){
                    callback(new Error('两次密码不一致'));
                }else{
                    callback();
                }
            },
            addNatural(){//新增资质等级
                this.isHideNatural = false;
                this.naturalForm.push(
                    {
                        qualificationName:'',//资质名称
                        certificateNumber:'',//资质证书编号
                        validityPeriod:'',//资质证书有效期
                    }
                );
            },
            removeNatural(index){//删除资质等级
                var form = 'naturalForm'+index;
                this.$refs[form][0].clearValidate();
                this.naturalForm.splice(index,1);
                if(this.naturalForm.length == 0){
                    this.isHideNatural = true;
                }
                for(var i = 0;i < this.naturalForm.length;i++){
                    this.$refs['naturalForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            addPartner(){//新增股东
                this.partnerForm.push(
                    {
                        stockholderName:'',//股东姓名
                        stockholderCreditNumber:''//股东身份证
                    }
                );
            },
            removePartner(index){//删除股东
                var form = 'partnerForm'+index;
                this.$refs[form][0].resetFields();
                this.partnerForm.splice(index,1);
                for(var i = 0;i < this.partnerForm.length;i++){
//                    console.log(this.$refs['partnerForm'+i])
                    this.$refs['partnerForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            addContact(){//新增联系人
                this.contactForm.push(
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'0'//是否主联系人（0：否，1：是）}
                    }
                );
            },
            removeContact(index){//删除联系人
                var form = 'contactForm'+index;
                this.$refs[form][0].resetFields();
                this.contactForm.splice(index,1);
                for(var i = 1;i < this.contactForm.length;i++){
                    this.$refs['contactForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            addStrategy(){//添加战略合作
                var _this = this;
                var item = {
                    suppliersId: '', //供方id
                    cooperativeUnitName: '',//合作单位名称
                    cooperativeCategoryName: '',//合作类别名称
                    cooperativeStartTime: '',//合作起始时间
                    cooperativeEndTime: '',//合作截止时间
                    awards: '',//所获奖项
                    cooperativeAreaName: '',//合作区域名称
                    cooperationAmount: '',//合作额度
                    lstattachmentVO: [], //合同附件
                    index : Math.random()+new Date().getTime()
                };
                _this.strategyForm.push(item);
            },
            removeStrategy(index){//移除战略合作
                var form = 'strategyForm'+index;
                this.$refs[form][0].resetFields();
                this.strategyForm.splice(index,1);
            },
            addCommon(){//添加一般合作
                var _this = this;
                var item = {
                    suppliersId: '', //供方id
                    cooperativeUnitName: '',//合作单位名称
                    cooperativeProjectName: '',//合作项目名称
                    cooperativeProjectScale: '',//项目规模
                    cooperationScope: '',//合作范围
                    cooperativeAreaName: '',//合作区域名称
                    cooperationAmount: '',//合作额度
                    lstattachmentVO: [], //合同附件
                    index : Math.random()+new Date().getTime()
                };
                _this.commonForm.push(item);
            },
            removeCommon(index){//移除一般合作
                var form = 'commonForm'+index;
                this.$refs[form][0].resetFields();
                this.commonForm.splice(index,1);
                console.log(this.commonForm)
            },
            sendCode(){//发送验证码
                var _this = this;
                var countDownEl = document.querySelector('.countDown');
                var sendCodeEl = document.querySelector('.sendCode');
                _this.$refs.userForm.validateField('userName',function(err){
                    if(!err){//如果没有错误信息，就代表手机号验证通过了，就发送验证码；
                        _this.isSendLoading = true;
                       _this.$root.getHttp(`v1/login/public/sendSmsCode/${_this.userForm.userName}`,function(res){
//                           console.log('验证码',res);
                           _this.isSendLoading = false;
                           countDownEl.style.display = 'block';//发送成功,显示倒计时；
                           sendCodeEl.style.display = 'none';
                           var time = setInterval(function(){
                               if(parseInt(countDownEl.innerHTML) == 1){
                                   countDownEl.innerHTML = '60S';
                                   countDownEl.style.display = 'none';
                                   sendCodeEl.style.display = 'block';
                                   clearInterval(time);
                                   return;
                               }
                               countDownEl.innerHTML = parseInt(countDownEl.innerHTML)-1 + 'S';
                           },1000);

                       })
                    } else {
                        console.log('error')
                    }
                })
            },
            handleClick(tab, event) {//tabs标签页切换
                console.log(tab, event);
            },
            toRegister(){
                if(this.checked) {
                   this.centerDialogVisible = false;
                } else {
                    this.$alert('请先勾选"已阅读注册须知"', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                }
            },
            toLogin(){
                this.$router.push('/login/masterCenter');
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
            selectSuperiorName(){//加载供方分类树形数据
                this.tree.defaultKeys = this.registerForm.supplierCategoryIds.split(',');
                this.tree.supplierCategoryDialog = true;
            },
            handleCloseSupplierCategory(){
                this.tree.supplierCategoryDialog = false;
            },
            handleConfirmSupplierCategory(){ //设置供方分类
                let that = this;
                let selectedData = this.$refs['treeSupplierCategory'].getCheckedNodes(true);
                let supplierCategoryIdsArr = [];
                let supplierCategoryNamesArr = [];
                for(let i=0; i<selectedData.length; i++){
                    supplierCategoryIdsArr.push(selectedData[i].id);
                    supplierCategoryNamesArr.push(selectedData[i].text);
                }

                //设置供方服务类别
                let selectedDataAll = this.$refs['treeSupplierCategory'].getCheckedNodes();
                let selectedDataHalf = this.$refs['treeSupplierCategory'].getHalfCheckedNodes();
                let selectedDataMain = selectedDataAll.concat(selectedDataHalf);
                let supplierServiceCategoryIdsArr = [];
                let supplierServiceCategoryNamesArr = [];
                for(let i=0; i<selectedDataMain.length; i++){
                    if(!selectedDataMain[i].parentId){
                        supplierServiceCategoryIdsArr.push(selectedDataMain[i].id);
                        supplierServiceCategoryNamesArr.push(selectedDataMain[i].text);
                    }
                }
                if(supplierServiceCategoryIdsArr.length == 0){
                    that.$alert('请选择供方分类', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return;
                }
                // if(supplierServiceCategoryIdsArr.length > 1){
                //     that.$alert('供方分类最多只能有一个一级分类', '提示', {
                //         confirmButtonText: '确定',
                //         type: 'warning'
                //     });
                //     return;
                // }
                that.registerForm.supplierCategoryIds = supplierCategoryIdsArr.join(',');
                that.registerForm.supplierCategoryNames = supplierCategoryNamesArr.join(',');

                that.registerForm.supplierServiceCategoryIds = supplierServiceCategoryIdsArr.join(',');
                that.registerForm.supplierServiceCategoryNames = supplierServiceCategoryNamesArr.join(',');
                that.tree.supplierCategoryDialog = false;
            },
            handleCheckChange(data, node) {
                if(node.checked){
                    this.$refs['treeSupplierCategory'].setChecked(data.id, false, true);
                }else{
                    this.$refs['treeSupplierCategory'].setChecked(data.id, true, true);
                }

            },
            submit(){
                var _this = this;
//                cooperativeCategoryName  合作类别，需要传string
//                intentionRegionalCompanyIds 需要传字符串，传了数组，需要转成字符串
//                enterpriseRegistrationYear 需要传字符串，传了date;
                //整个表单验证
                _this.valid_first('submit',()=>{
                    _this.valid_second('submit',()=>{
                        _this.valid_third('submit',()=>{
                            if(!_this.canSubmit) return;
                            if(_this.affiliateForm.hasRelateParentCompany == 0){
                                _this.affiliateForm= {
                                    //获取关联母公司信息
                                    hasRelateParentCompany: '0',//有无关联公司（0：否，1：是）hasRelateParentCompany
                                        relateParentCompanyName:'',//关联母公司名称
                                        relateParentCompanyId: '',//关联母公司Id
                                        legalRepresentative:'',//法人
                                        socialCreditCode:'',//统一社会信用代码
                                        businessLicenseNumber:'',//营业执照号
                                        creditLicenseCodeFlag: 1,//1 代表统一社会信用代码，2 代表营业执照号
                                        registAddress:''//注册地址
                                }
                            }

                            /* _this.baseBusinessInfo.forEach(item =>{
                                let date = new Date(item.businessYear);
                                let year = date.getFullYear();
                                item.businessYear = year;
                            })*/

                            var formParams = {
                                "lstSuppliersContactInfoVO": _this.contactForm,//供方信息-联系方式
                                "lstSuppliersLastThreeMajorAchievenVO":  _this.strategyForm, //战略合作
                                "lstSuppliersLastThreeCommonAchievenVO": _this.commonForm, //一般合作
                                "lstSuppliersQualificationGradeVO": _this.naturalForm,//供方信息-资质等级
                                "lstSuppliersStockHolderVO": _this.partnerForm,//供方信息-股东
                                "suppliersBusinessSituationVO": _this.businessForm,//供方信息-业务状况
                                // "suppliersObtainInformationVO": _this.InfoTypeForm,//供方信息-获取信息类型
                                "suppliersRelateParentCmpyVO": _this.affiliateForm,//关联母公司
                                "suppliersVO": _this.registerForm,//供方基本信息
                                "userRequestVO": {
                                    userName:  _this.userForm.userName,
                                    password: md5(_this.userForm.password),
                                    verificationCode: _this.userForm.verificationCode
                                },//注册信息
    //                          "lstattachmentVO": {} //附件清单
                                "mapAttachmentVOs": {}, //附件清单
                                ssupplierBankAccountList:_this.bankInfoForm,
                                ssuppliersBusinessSituationList:_this.baseBusinessInfo

                            };
                            for(let key in _this.mapAttachmentOptions){
                                formParams.mapAttachmentVOs[key] = _this.mapAttachmentOptions[key].fileList;
                            }
                            formParams.suppliersVO.intentionRegionalCompanyIds = _this.registerForm.intentionRegionalCompanyIds;
                            if(Array.isArray(_this.registerForm.undertakeAreas)){
                                formParams.suppliersVO.undertakeAreas = _this.registerForm.undertakeAreas.join(',');
                            }
    //                        console.log(formParams);
                            _this.$root.postHttp('/v1/sSuppliers/public/outerSaveSuppliers',formParams,function(res){
                                _this.$alert('注册成功', '提示', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    callback: action => {
                                        _this.$router.push('/login/masterCenter');
                                    }
                                });
                            },function(){
    //                          _this.registerForm.intentionRegionalCompanyIds = _this.registerForm.intentionRegionalCompanyIds.split(',');
                            })
                        })
                    });
                });
            },
            prev(){//上一步
              if(parseInt(this.activeName) == 0){
                  return;
              }else if(parseInt(this.activeName) == 2){
                 /* for(var i in this.mapAttachmentOptions) {
                      if(i == 2 || i == 3){
                          if(!this.mapAttachmentOptions[i].fileList.length) {
                              this.$alert('带*的附件必须上传', '提示', {
                                  confirmButtonText: '确定',
                                  type: 'warning'
                              });
                              return;
                          }
                      } else {
                          this.activeName = '1';
                      }
                  }*/
                  this.activeName = '3';
              } else if(parseInt(this.activeName) == 1){
                  this.activeName = '0';
              } else if(parseInt(this.activeName) == 3){
                  this.activeName = '1';
              }
//              this.activeName= (parseInt(this.activeName)-1) + '';
            },
            next(){//下一步
                var _this = this;
                if(parseInt(_this.activeName) == 0){
                    this.valid_first('next');
                } else if(parseInt(_this.activeName) == 1){
                   _this.valid_second('next');
                } else if(parseInt(_this.activeName) == 3){
                    _this.valid_third('next');
                }
            },
            valid_third(type,fn){
                let _this = this;
                let bankInfoValid = this.validateByMultipleForm(this.bankInfoForm,'bankInfoFormItem');
                if(!bankInfoValid ){
                    _this.canSubmit = false;
                    // _this.$alert('请把带*的必填字段填写完整', '提示', {
                    //     confirmButtonText: '确定',
                    //     type: 'warning'
                    // });
                    return;
                }else{
                    _this.canSubmit = true;
                    _this.activeName = '2';
                    fn && fn();
                }
            },
            valid_second(type,fn){
                let _this = this;
                let flag = true;
                let flagProject = true;
                // /*战略合作*/
                // _this.strategyForm.forEach((item) => {
                //     if(item.cooperativeUnitName && !_this.$root.checkNumber(item.cooperationAmount)){
                //         flag = false;
                //     }
                // });
                // /*一般合作*/
                // _this.commonForm.forEach((item) => {
                //     if(item.cooperativeUnitName && !_this.$root.checkNumber(item.cooperationAmount)){
                //         flag = false;
                //     }
                //     if(item.cooperativeUnitName && !item.cooperativeProjectName){
                //         flagProject = false;
                //     }
                // });
                // if(!flagProject){
                //     _this.$alert('一般合作类型下请填写合作项目!',{type:'warning'});
                //     return false;
                // }
                // if(flag){
                //     if(type == 'submit'){
                //         _this.canSubmit = true;
                //     }else{
                //         _this.activeName = '2';
                //     }
                // }else{
                //     _this.$alert('合作额度必须为数字格式!',{type:'warning'});
                //     _this.activeName = '1';
                // }
                let strategyFormValid = this.validateByMultipleForm(this.strategyForm,'strategyForm'); // 战略合作
                let commonFormValid = this.validateByMultipleForm(this.commonForm,'commonForm'); // 一般合作
                if( !strategyFormValid ||  !commonFormValid){
                    _this.canSubmit = false;
                    // _this.$alert('请把带*的必填字段填写完整', '提示', {
                    //     confirmButtonText: '确定',
                    //     type: 'warning'
                    // });
                    return;
                }else{
                    _this.canSubmit = true;
                    _this.activeName = '3';
                    fn && fn();
                }
                // if(!bankInfoValid ){
                //     _this.canSubmit = false;
                //       _this.$alert('请把带*的必填字段填写完整', '提示', {
                //         confirmButtonText: '确定',
                //         type: 'warning'
                //     });
                //     return;
                // }else{
                //    _this.activeName = '2';
                //     fn && fn();
                // }
            },
            valid_first(type,fn){
                var _this = this;
                console.log(_this.baseBusinessInfo)
                var arr_first = ['userForm','registerForm'];
                var naturalFormArr = [];
                _this.naturalForm.forEach((item,i) => {
                    naturalFormArr.push('naturalForm'+i)
                });
                var partnerFormArr = [];
                _this.partnerForm.forEach((item,i) => {
                    partnerFormArr.push('partnerForm'+i)
                });
                var contactFormArr = [];
                _this.contactForm.forEach((item,i) => {
                    contactFormArr.push('contactForm'+i)
                });
                arr_first = arr_first.concat(naturalFormArr,partnerFormArr,contactFormArr);
                if(_this.affiliateForm.hasRelateParentCompany == 0){
                    arr_first.push('businessForm');
                }else{
                    arr_first.push('businessForm','affiliateForm');
                }
                let isSubmit = true;
                arr_first.forEach((formName) => {
                    let form = Array.isArray(_this.$refs[formName]) ? _this.$refs[formName][0] : _this.$refs[formName];
                    form.validate((valid,obj) => {
                        if(!valid){
                            isSubmit = false;
                            let key = ''
                            Object.keys(obj).forEach(function (k,v,i) {
                                if(v == 0){
                                    key = k
                                }
                            })
                            _this.$alert(obj[key][0].message, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            });

                        }
                    });
                });
                let baseBusinessInfoValid = this.validateByMultipleForm(this.baseBusinessInfo,'baseBusinessInfoItem'); // 近年营业额
                if(!baseBusinessInfoValid){
                    isSubmit = false;
                }
                _this.validateLoading = true;
                setTimeout(()=>{
                    if(isSubmit){
                        if(type == 'submit'){
                            for(var i in _this.mapAttachmentOptions) {
                                if(i == 2){
                                    if(!_this.mapAttachmentOptions[i].fileList.length) {
                                        _this.$alert('带*的附件必须上传', '提示', {
                                            confirmButtonText: '确定',
                                            type: 'warning'
                                        });
                                        _this.canSubmit = false;
                                        _this.validateLoading = false;
                                        return;
                                    }
                                } else {
                                    _this.canSubmit = true;
                                    _this.validateLoading = false;
                                }
                            }
                            if(_this.canSubmit){
                                _this.validateLoading = false;
                                fn && fn();
                            }
                        } else {
                            _this.activeName = '1';
                            _this.validateLoading = false;
                        }

                    } else {
                        // _this.$alert('请把带*的必填字段填写完整', '提示', {
                        //     confirmButtonText: '确定',
                        //     type: 'warning'
                        // });
                        _this.canSubmit = false;
                        _this.validateLoading = false;
                        _this.activeName = '0';
                    }
                },1000);
            },

                        // 新增银行信息
            addBankInfo(){
                let obj = {
                    accountType:'', // 开户行类型 1：国内 2：国外
                    accountNumber:'' , // 银行账号
                    bankName:'', // 开户行
                    bankNumber:'' , // 联行号
                }
                this.bankInfoForm.push(obj);
            },

            // 删除银行信息
            removeBankInfo(index){
                this.bankInfoForm.splice(index,1);
            },

            // 新增营业额信息
            addBaseBusiness(){
                let obj = {
                    businessYear:'', // 年份
                    businessVolume:'' // 营业额
                }
                this.baseBusinessInfo.push(obj);
            },

            // 删除营业额信息
            removeBaseBusiness(index){
                this.baseBusinessInfo.splice(index,1);
            },

            // 循环多表单验证
            validateByMultipleForm(formList,formName){
                let _this = this
                let resultValidate = [];
                formList.forEach((item,index)=>{
                    this.$refs[formName + index][0].validate((valid,obj)=>{
                        if(valid){
                            resultValidate.push(true);
                        }else{
                            resultValidate.push(false);
                            let key = ''
                            Object.keys(obj).forEach(function (k,v,i) {
                                if(v == 0){
                                    key = k
                                }
                            })
                            _this.$alert(obj[key][0].message, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            });
                        }
                    })
                })
                if(resultValidate.every(item => item || item == undefined)){
                    return true;
                }else{
                    return false;
                }
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/_var.scss";
  /*  body {
        background: $--primary-fill-color;
    }*/
    #registerTotal {
        background: $--primary-fill-color;
    }
    dl {
        margin: 0;
    }
    a {
        text-decoration: none;
    }
    /*头部导航*/
    .registerHeader {
        background: #fff;
        & .main-container {
            overflow: hidden;
            padding: 18px 0;
            height: 80px;
            box-sizing: border-box;
            line-height: 34px;
        }
        & .left_h {
            float: left;
            & .logoImg {
                display: inline-block;
                vertical-align: middle;
                & img {
                    width: 240px;
                    height: 29px;
                }
            }
            & span {
                margin-left: 20px;
                font-size: 16px;
            }
        }
        & .right_h {
            float: right;
            & .help {
                display: inline-block;
                padding: 0 20px 0 25px;
                background: url('../../assets/images/register/icon01.png') no-repeat left center;
            }
            & .help:hover,
            & .wechat:hover {
                color: $--text-color-light;
            }
            & .wechat {
                display: inline-block;
                padding: 0 0 0 43px;
                background: url('../../assets/images/register/icon02.png') no-repeat 15px center;
            }
            .line {
                display: inline-block;
                width: 1px;
                height: 14px;
                background: $--text-color-lighter;
            }
        }
        & a {
            font-size: 14px;
            color: $--text-color-lighter;
        }
    }
    /*banner*/
    #registerTotal .banner {
        margin: 0 0 30px;
        & img {
            width: 100%;
            height: 150px;
        }
    }
    /*注册须知*/
    #article {
        & .el-dialog {
            border-radius: 15px;
        }
        & .el-dialog__header {
            text-align: left;
            font-weight: bold;
            border-bottom: 1px solid $--text-color-light;
        }
        .el-dialog__title {
            padding-left: 30px;
            background: url('../../assets/images/register/icon_tit.png') no-repeat 0 1px;
        }
        .el-dialog--center .el-dialog__body {
            height: 320px;
            overflow-y: scroll;
        }
        & .center {
            text-align: center;
        }
        & section {
            margin-top: 15px;
            padding: 10px;
            color: $--primary-color;
            border: 1px solid $--secondary-fill-color;
        }
        & .padd {
            padding: 5px 0;
        }
        & .indent {
            text-indent: 28px;
        }
        & .indent2 {
            text-indent: 38px;
            /*padding: 0 14px;*/
        }
        & .readed {
            /*margin-top: 20px;*/
            padding: 15px;
            border-top: 1px dashed $--text-color-lighter;
            text-align: left;
        }
        & .el-button{
            padding: 10px 36px;
        }
        & .disagree {
            background: $--text-color-lighter;
            border: none;
        }
        & .el-dialog__footer {
            padding: 0 20px 20px;
        }
    }
    /*tab切换*/
    #registerTotal {
        padding-bottom: 80px;
        background: $--primary-fill-color;
        .baseMain {
            background: #fff;
            padding-bottom: 30px;
        }
    }
    #registerTotal .el-tabs {
        /*background: #fff;*/
        padding-top: 20px;
        & .el-tabs__header {
            margin: 0 0 30px;
        }
        & .el-tabs__nav {
            margin-left: 40px;
        }
        & .el-tabs__item {
            font-size: 16px;
            height: 50px;
        }
        & .el-tabs__item.is-active {
            color: $--text-color;
            font-weight: 700;
        }
        & .el-tabs__active-bar {
            bottom: -2px;
            height: 12px;
            background: url('../../assets/images/register/at.png') no-repeat center 0;
        }
        & .el-tabs__nav-wrap::after {
            height: 1px;
            background-color: $--secondary-fill-color;
        }
    }
    #registerTotal .small-container {
        width: 1120px;
        margin: 0 auto;
        & form {
            width: 95%;
            margin: 15px auto;
            & .el-form-item__label {
                padding: 0 22px 0 0;
                color: #333;
            }
            & .el-form-item__content {
                width: 56%;
                text-align: left;
                & .el-select {
                    /*width: 35%;*/
                }
            }
            & .contentFull .el-form-item__content{
                width: 100%;
            }
            & .selectFull .el-select {
                width: 100%;
            }
            & .time .el-form-item__content {
                width: 80%;
            }
            & .startTime.time .el-form-item__content {
                width: 100%;
            }
            & .validity .el-form-item__content {
                width: 100%;
            }
            & .unit {
                width: 85%;
                margin-right: 10px;
            }
            & .capital .el-form-item__content {
                width: 100%;
            }
            & .capital .unit {
                width: 28%;
            }
            & .veriCodeItem {
                position: relative;
                & input {
                    width: 60%;
                }
                & button {
                    position: absolute;
                    right: 0px;
                    top: 2px;
                }
                & .el-input__suffix {
                    right: 140px;
                }
                & .el-form-item__content {
                    width: 66%;
                }
                & .countDown {
                    position: absolute;
                    top: 2px;
                    right: 10px;
                    color: $--primary-color;
                    border: 1px solid $--primary-color;
                    box-sizing: border-box;
                    height: 36px;
                    display: inline-block;
                    /*padding: 0 30px;*/
                    border-radius: 3px;
                    width: 88px;
                    line-height: 36px;
                    text-align: center;
                }
            }
            & .creditCode,
            & .capitalAddr,
            & .companyNature {
                position: relative;
                 & .el-form-item__content>.el-input {
                     position: absolute;
                     right: 0;
                     top: 0;
                     width: 180px;
                 }
            }
            & .creditCode {
                .el-form-item__content {
                    width:100%;
                }
                & .el-form-item__content>.el-input {
                    width: 220px;
                    right: 560px;
                }
                .tip {
                    margin-left: 250px;
                }
                & .el-form-item__error {
                    left: 30%;
                }
            }
            & .companyNature {
                & .el-form-item__content>.el-input {
                    right: 250px;
                }
            }
            & .capitalAddr .el-form-item__content {
                width: 70%;
                &>.el-input {
                    width: 80%;
                    position: static;
                }
                & .el-input__suffix {
                    right: 78px;
                }
            }
        }
        & .naturalForm  {
            padding: 20px 10px 5px;
            border: 1px solid #dcdfe6;
            border-radius: 3px;
            & .el-form-item__label {
                padding: 0;
            }
            & .el-form-item__content {
                width: 60%;
            }
        }
        & h3,
        & h4{
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }
        & .strategyForm {
            margin-top: 0;
            & h3 {
                margin: 0 0 30px;
            }
            & .tips {
                margin-right: 20px;
            }
        }
        & .ordinary{
            width: 100%;
        }
        & .tip {
              margin-left: 10px;
              color: $--primary-color;
              font-size: 12px;
          }
        & .tips {
            float: right;
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            color: $--text-color-lighter;
            background: url('../../assets/images/register/icon03.png') no-repeat left center;
        }
        & .add {
            float: right;
            font-size: 14px;
            cursor: pointer;
            & img {
                vertical-align: middle;
                width: 70px;
                height: 26px;
            }
        }
        & .dele img {
            transform: scale(1);
            transition: .5s;
            width: 34px;
            height: 34px;
        }
        .dele:hover img {
            transform: scale(1.1);
        }
        & .remarks {
            width: 95%;
        }
    }
    .uploadAnnex {
        overflow: hidden;
        & .el-upload {
            float: left;
        }
        & .el-upload-list {
            float: left;
            margin-left: 5px;
        }
        &>button {
            float: right;
            /*margin-right: 20px;*/
        }
    }
   #achievement .small-container form .unit {
        width: 85%;
        margin-right: 10px;
    }
    .strategiCooperation{
        margin-top: 10px;
        padding: 20px 10px 5px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Register.vue